module.exports = __webpack_public_path__ + "static/img/ldj.58b39ee9.jpg";